<template>
  <widget-field-text
    :model-value="modelValue"
    class="widget-field-search"
    left-icon="search"
    @update:model-value="$emit('update:model-value', $event)"
  />
</template>

<script lang="ts">
import WidgetFieldText from '@widgets/shared/components/fields/WidgetFieldText.vue'
import { widgetFieldEvents, widgetFieldProps } from '@widgets/shared/components/fields/types'
import { defineComponent } from '@/composition/vue/compositionApi'

export default defineComponent({
  components: { WidgetFieldText },
  props: {
    ...widgetFieldProps,
  },
  emits: widgetFieldEvents,
})
</script>

<style lang="scss" scoped>
.widget-field-search {
  :deep {
    .q-field__control {
      height: 36px;
    }
    .q-field__prepend {
      margin-left: 12px;
    }
  }
}
</style>
